const SelectedOption = (el) => el.options[el.selectedIndex]

export default SelectedOption
